import React from 'react';
import genericField from './generic-field';

const Text = genericField('hidden');

export default Text;
